import React from 'react'
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { toast } from 'react-toastify';
import swal from 'sweetalert';

export const TableDropdown = (props) => {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
    const handleClose = () => {
		setAnchorEl(null);
	};

    function addRow(tableName ) {
        props.settablesExtracted(prev => {
				let tempTables = {...prev}

				let prevRows = Object.keys(tempTables[tableName])
                if (prevRows.length ===0){
                    toast.error("Add column First")
                    return tempTables
                }
				let row = tempTables[tableName][prevRows[0]].map(obj => {
					return {
						table: tableName,
						entity: obj.entity,
						value: '',
						status: 'new added',
						version: 0,
						entity_valid: '',
						rule_applied: '',
						entity_validation_explanation: '',
						annotated: true,
                        originalValue : '',
                        bounding_box: []
					}
				})
				let rname = `row_${prevRows.length}`
				tempTables[tableName][rname] = row

				return tempTables
			})
        if (props.DocLockedForMe){
                props.setchangeDetect(true)
                props.setchangeAdd(p=>p+1)
            }
		handleClose()
	}

    function addCol(tableName ) {
        props.settablesExtracted(prev => {
				let tempTables = {...prev}

				let prevRows = Object.keys(tempTables[tableName])
                if (prevRows.length ===0) {
                    tempTables[tableName]['row_0'] = [{
                        table: tableName,
                        entity: '',
                        value: '',
                        status: 'new added',
                        version: 0,
                        entity_valid: '',
                        rule_applied: '',
                        entity_validation_explanation: '',
                        annotated: true,
                        originalValue : '',
                        bounding_box: []
                    }]
                    return tempTables
                }
                else{
                    prevRows.map(row => {
                        tempTables[tableName][row].push({
                            table: tableName,
                            entity: '',
                            value: '',
                            status: 'new added',
                            version: 0,
                            entity_valid: '',
                            rule_applied: '',
                            entity_validation_explanation: '',
                            annotated: true,
                            bounding_box: []
                        })
                    return null
                    })
                    return tempTables
                }
			})
        
        if (props.DocLockedForMe){
            props.setchangeDetect(true)
            props.setchangeAdd(p=>p+1)
        }
        handleClose()
			
	}

    function deleteTable(tableName){
        swal('Are you sure you want to Delete this table along with its bounding box?', {
			buttons: ['No', 'Yes'],
		}).then((value) => {
			if (value) {
                props.settablesExtracted(p => {
                    let tp = {...p}
                    delete tp[tableName]
                    return tp
                })
                props.settotalTablesExtracted(prev =>  {
                    let pgbx = { ...prev };
					delete pgbx[props.PageNo][tableName]
					return pgbx;
				});
                props.settableBoxes(p => {
                    let tp = {...p}
                    console.log(tp[props.PageNo] ,tableName,tp[props.PageNo].filter(itm => itm.entity !== `table_${tableName}`), "tps");
                    
                    tp[props.PageNo] = tp[props.PageNo].filter(itm => itm?.entity?.toLowerCase() !== `table_${tableName}`)
                    return tp
                })
                props.settableTitle(p => {
					let tp = {...p}
					delete  tp[props.PageNo][tableName]
					return tp
				})
                props.setExtractionError(p=> {
                    let tp = {...p}
                    delete tp[`${props.PageNo}_${props.tableName}`]
                    return tp
                })
				if (props.DocLockedForMe){
					props.setchangeDetect(true)
					props.setchangeAdd(p=>p+1)
					
				}
			}
		});


    }

    return (
        <>
        
        {!props.IsCSV && <div className="flex gap-3 items-start">
            <Button
                disabled={props.IsCSV || props.Freez || !props.DocLockedForMe}
                id={`button-${props.tableName}`}
                aria-controls={undefined}
                aria-haspopup="true"
                aria-expanded={undefined}
                onClick={handleClick}
            >
                <h2>TABLE_{props.tableName}</h2>
                <span className="inline-block material-icons text-black text-sm ml-3 size-6 border rounded-md moreIco">
                    more_vert
                </span>
            </Button>
            <Menu
                id={`menu-${props.tableName}`}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': `button-${props.tableName}`,
                }}
            >
                <MenuItem onClick={() => addCol(props.tableName)}>
                    Add Column
                </MenuItem>
                <MenuItem onClick={(e) => {
                    addRow(props.tableName)
                }}>Add Row</MenuItem>
                
                <MenuItem onClick={() => {props.setisDeleteEnable(p =>{
                    let tp = {...p}
                    if ( props.tableName in tp ) { 
                        tp[props.tableName] = ! tp[props.tableName]
                    }
                    else{
                        tp[props.tableName] = true
                    }
                    return tp 
                })
                handleClose()
            }
                }>
                   {props.isDeleteEnable[props.tableName] ? 'Hide Delete' : 'Delete'}
                </MenuItem>
                <MenuItem onClick={() => deleteTable(props.tableName)}>
                    Delete Table
                </MenuItem>
            </Menu>
            <div className='flex flex-col items-start  gap-1 '>

            <button className="bg-blue-800 hover:bg-indigo-700 px-3 py-2 rounded-md text-white disabled:bg-gray-200 disabled:text-gray-500 disabled:hover:text-gray-500 text-sm flex items-center font-medium whitespace-nowrap overflow-hidden text-ellipsis" disabled={props.IsCSV || props.Freez || !props.DocLockedForMe || props.extract_table_hook?.isPending} onClick={()=> props.ExtractTable(props.tableName, props.PageNo)}>Extract</button>
            <p className='text-sm text-red-600 '>{props.ExtractionError[`${props.PageNo}_${props.tableName}`]}</p>

            </div>
        </div>}
        </>
    )
}
